import { Dialog, DialogWindow } from '../dialog';
import { Link } from '../buttons';
import { showErrorNotification } from '../notificationToaster';
import React, { useState } from 'react';
import { T } from 'src/shared/helpers';
import styled from 'styled-components';
import GeneralConditionsAndMarketing from '.';

export const DialogDecoratorCustom = styled(DialogWindow)`
    max-width: 650px;
`;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding-bottom: 10px;

    h1 {
        font-size: 20px;
        font-weight: bold;
        line-height: 28px;
        margin: 0;
    }

    > p {
        font-size: 14px;
        line-height: 20px;
        margin: 0;
    }
`;

interface GeneralConditionsAndMarketingDialogProps {
    onConfirm: (isThirdPartyChecked: boolean) => void;
}

const GeneralConditionsAndMarketingDialog = ({ onConfirm }: GeneralConditionsAndMarketingDialogProps) => {
    const [isGeneralConditionsChecked, setIsGeneralConditionsChecked] = useState(false);
    const [isThirdPartyChecked, setIsThirdPartyChecked] = useState(false);

    const handleClickConfirm = () => {
        if (!isGeneralConditionsChecked) {
            showErrorNotification({
                message: T._('You must accept the terms of use.', 'Admin')
            });
            return;
        }

        onConfirm(isThirdPartyChecked);
    };

    return (
        <Dialog
            windowDecorator={DialogDecoratorCustom}
            buttons={[
                {
                    label: T._('Start now', 'Admin'),
                    outline: false,
                    disabled: !isGeneralConditionsChecked,
                    onClick: handleClickConfirm
                }
            ]}
            showCloseButton={false}
        >
            <Container>
                <h1>{T._('Start your 14-days free trial', 'Admin')}</h1>
                <p>{T._(`Welcome to your free 14-day trial of Zakeke!`, 'Admin')}</p>
                <p>{T._(`Simply click the "Start now" button below to begin revolutionizing how your customers purchase your products!`, 'Admin')}</p>
                <p>
                    {T._(`If you have any questions about the free trial, you can find`, 'Admin')}{' '}
                    <Link target='_blank' href='https://zakeke.zendesk.com/hc/en-us/sections/360001927033-Plans-and-Pricing'>
                        {T._('FAQs', 'Admin')}
                    </Link>{' '}
                    {T._(`here to help you`, 'Admin')}.
                </p>
                <GeneralConditionsAndMarketing
                    isGeneralConditionsChecked={isGeneralConditionsChecked}
                    isThirdPartyChecked={isThirdPartyChecked}
                    setIsGeneralConditionsChecked={setIsGeneralConditionsChecked}
                    setIsThirdPartyChecked={setIsThirdPartyChecked}
                />
            </Container>
        </Dialog>
    );
};

export default GeneralConditionsAndMarketingDialog;
